import { useHasPermission } from '@/auth';
import useClientState from '@/state/useClientState';
import { Group } from '@visx/group';

import useProgressiveWerklijnen from '../../hooks/useProgressiveWerklijnen';

import Werklijn from './Werklijn';

const Werklijnen = () => {
  const { werklijnen } = useProgressiveWerklijnen();
  const mwdWidth = useClientState((state) => state.mwd.width);
  const isAllowedToMutate = useHasPermission('mwd.mutate');

  return (
    <Group width={mwdWidth}>
      {werklijnen.map((werklijn) => (
        <Werklijn key={`werklijn-${werklijn.werklijnId}`} isAllowedToMutate={isAllowedToMutate} werklijn={werklijn} />
      ))}
    </Group>
  );
};
export default Werklijnen;
